import { remove } from "diacritics";

function canonize() {
  return function (string) {
    return remove(string).toLowerCase();
  };
}

export default canonize;
